import type { HelpFile } from '../../types/help'
import { ExistingPartySelectorTestIds } from '../../../testids/ExistingPartySelectorTestIds'

export const existingPartySelectorHelp: HelpFile = {
  docPage: '/docs/onboarding/existing-party',
  texts: {
    [ExistingPartySelectorTestIds.existingPartySelector]:
      'Attach this onboarding to an existing party instead of creating a duplicate.',
  },
}
